import * as types from 'store/modules/hrms55x/mutation-types'
import hrms55x from 'api/hrms55x'
import swal from 'sweetalert'
import hrms55xLabels from 'assets/labels/hrms55x'
import { hrms55xColumns } from 'assets/columns/hrms55x'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    labels: hrms55xLabels,
    columns: hrms55xColumns(),
    index: {
      total: 0,
      rows: []
    },
    response: {
      status: '',
      message: ''
    }
  },
  getters: {
    [types.GET_HRMS55X_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS55X_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS55X_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS55X_INDEX] (state) {
      return state.index
    }
  },
  mutations: {
    [types.SET_HRMS55X_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS55X_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRMS55X_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRMS55X_INDEX] (state, data) {
      state.index = data
    }
  },
  actions: {
    [types.TOGGLE_HRMS55X_PAGE] ({ commit }, page) {
      let indexDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
      }
      commit(types.SET_HRMS55X_INDEX_DISP, indexDisp)
    },
    [types.RECEIVED_HRMS55X_COLUMNS_LABELS] ({ commit }) {
      hrms55x.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS55X_COLUMNS, data.labels)
          commit(types.SET_HRMS55X_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS55X_INDEX] ({ commit }, searchParams) {
      hrms55x.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS55X_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS55X_INDEX, objData)
        })
    },
    [types.RECEIVED_HRMS55X2_INDEX] ({ commit }, searchParams) {
      hrms55x.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS55X_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS55X_INDEX, objData)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms55x/index.js